import { ClaimLink } from 'linkdrop-p2p-sdk'

type TCheckDepositTxHash = (
  claimLink: ClaimLink
) => Promise<boolean | {amount: number}>

const checkDepositTxHash: TCheckDepositTxHash = (claimLink) => {
  return new Promise((resolve, reject) => {
    (async () => {

      const interval = window.setInterval(async () => {
        if (claimLink) {
          const statusData = await claimLink.getStatus()
          if (statusData) {
            const { status } = statusData
            if (status === 'deposited') {
              resolve(true)
              clearInterval(interval)
            }
          }
        }
      }, 1000)
    
    })()
  })
}

export default checkDepositTxHash